










import { PropType, defineComponent } from '@vue/composition-api';

import { IFieldErrors, IWorkflowTransitionNode } from '@/models';
import {
  convertLogicalExpressionTreeToPredicateNodeList,
  convertPredicateNodeListToLogicalExpressionTree
} from '@/models/predicate/tree';

import { useProxiedModel } from '@/composable/proxymodel';

import WorkflowTransitionPredicateQueryTree from './WorkflowTransitionPredicateQueryTree.vue';

export default defineComponent({
  name: 'WorkflowTransitionPredicateQueryTreeBuilder',

  components: {
    WorkflowTransitionPredicateQueryTree
  },

  props: {
    value: {
      type: Array as PropType<IWorkflowTransitionNode[]>,
      required: true,
      default: () => []
    },
    fieldErrors: {
      type: Array as PropType<IFieldErrors[]>,
      default: (): IFieldErrors[] => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  setup(props) {
    const modelValue = useProxiedModel(
      props,
      'value',
      props.value,
      convertPredicateNodeListToLogicalExpressionTree,
      convertLogicalExpressionTreeToPredicateNodeList
    );

    return {
      modelValue
    };
  }
});
